import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { HealthcareFacilitiesApi } from '../../../apis/HealthcareFacilitiesApi/HealthcareFacilitiesApi.ts';
import { HealthcareFacility, IHealthcareFacility } from '../HealthcareFacility.ts';
import { useLowFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useLowFrequencyRefreshQuery.tsx';

export function useGetHealthcareFacilities() {
    return useLowFrequencyRefreshQuery({
        queryKey: [QueryKeys.healthcareFacilities],
        queryFn: async () => {
            const segments = location.pathname.split('/').filter(Boolean);
            if (segments[2] === 'hcpProfile' || segments[1] === 'hcpProfile') 
                return;
            
            const result: IHealthcareFacility[] | undefined = await HealthcareFacilitiesApi.getHealthcareFacilities();
            return result ? result.map((x) => new HealthcareFacility(x)) : result;
        },
    });
}
